<template>
  <div @mousewheel.stop ref="echarts" :style="{ width: width, height: height }"></div>
</template>
<script>
export default {
  name: 'EchartModule',
  data(){
    return{
      myChart: new Object()
    }
  },
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    option: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.myChart.resize();
    })
    this.getInit();
  },
  methods: {
    getInit(){
      const colors = [
        {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: '#01D9FE'
            },
            {
              offset: 1,
              color: '#0477D5'
            }
          ],
          global: false
        },
        {
          type: 'linear',
          x: 0,
          y: 1,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: '#FAD233'
            },
            {
              offset: 1,
              color: '#FFCC00'
            }
          ],
          global: false
        },
        '#F9E2C0',
        '#F67D3E',
        '#00B053',
        '#FF0000',
      ]
      let option = {
        ...this.option,
        ...(this.option.showZoom ? {
          dataZoom: [
              {
                  height: this.fontSizeFn(20),
                  moveHandleSize: 0,
                  bottom: this.fontSizeFn(15),
                  textStyle: {
                      color: '#8392A5'
                  },
                  dataBackground: {
                  areaStyle: {
                      color: '#8392A5'
                  },
                  lineStyle: {
                      opacity: 0.8,
                      color: '#8392A5'
                  }
                  },
                  brushSelect: true
              }, {
                  type: 'inside',
                  filterMode: 'filter'
              }
          ]
        } : {}),
        title: {
          show: false,
          ...this.option?.title
        },
        grid: {
          containLabel: true,
          bottom: 0,
          right: 0,
          left: 0,
          top: '5%',
          ...this.option?.grid,
        },
        color: this.option?.color ? this.option.color.map(item => {
          return colors[item]
        }) : colors,
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'shadow',
            crossStyle: {
              color: '#999',
            },
          },
          textStyle: {
            color: '#ffffff',
            fontSize: this.fontSizeFn(18),
          },
          extraCssText: 'border-color: rgba(0, 0, 0, 0.5);background-color: rgba(0, 0, 0, 0.5);',
          ...this.option?.tooltip
        },
        yAxis: this.option?.yAxis ? this.option.yAxis : {
          axisLabel: {
            fontSize: this.fontSizeFn(16)
          },
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: this.option?.xAxis?.interval,
            fontSize: this.fontSizeFn(16),
            formatter: this.option?.xAxis?.formatter
          },
          ...this.option?.xAxis
        },
        textStyle: {
          color: '#ffffff',
          fontSize: this.fontSizeFn(16),
          ...this.option?.textStyle
        },
        legend: {
          textStyle: {
            color: '#ffffff',
            fontSize: '0.12rem',
            ...this.option?.textStyle
          },
          itemWidth: this.fontSizeFn(25),
          itemHeight: this.fontSizeFn(14),
          ...this.option?.legend
        },
      }
      this.myChart = this.$echarts.init(this.$refs.echarts);
      option.clickFn && this.myChart.on('click', option.clickFn);
      option.getZrFn && this.myChart.getZr().on('click', option.getZrFn);
      this.myChart.setOption(option)
    }
  },
}
</script>
<style scoped></style>
